export const portfolios = [
    {
        id: 1,
        category: 'Typescript',
        image: 'https://supriya224.github.io/my-portfolio/assets/googl.png',
        github: 'https://github.com/supriya224/googleSearchEngine-clone',
        linkedin: 'https://main--thunderous-florentine-bb3b72.netlify.app/',
        title: 'Google clone',
        text: 'Nextjs,Typescript,React, TailwindCss',
    },
    {
        id: 2,
        category: 'Reactjs',
        image: 'https://supriya224.github.io/my-portfolio/assets/code.png',
        github: 'https://github.com/supriya224/codepen-clone',
        linkedin: 'https://supriya224.github.io/codepen-clone/',
        title: 'Codepen clone',
        text: 'React,React-codemirror2',
    },
    {
        id: 3,
        category: 'Typescript',
        image: 'https://supriya224.github.io/my-portfolio/assets/music.png',
        github: 'https://github.com/supriya224/Music-App',
        linkedin: 'https://supriya224.github.io/Music-App/',
        title: 'My own Music playlist-web-app',
        text: `ReactJs, Typescript, IndexDB, TailwindCss`,
    },
    {
        id: 17,
        category: 'Reactjs',
        image: 'https://supriya224.github.io/my-portfolio/assets/port.png',
        github: 'https://github.com/supriya224/my-portfolio',
        linkedin: 'https://my-portfolio-izav.vercel.app/my-portfolio',
        title: 'My portfolio',
        text: 'React,styled-component',
    },
    {
        id: 4,
        category: 'Reactjs',
        image: 'https://supriya224.github.io/my-portfolio/assets/note.png',
        github: 'https://github.com/supriya224/notes-web-app',
        linkedin: 'https://supriya224.github.io/notes-web-app/',
        title: 'React Notes-Web-App',
        text: 'ReactJs, ReactHooks, TailwindCss',
    },

    {
        id: 18,
        category: 'Reactjs',
        image: 'https://supriya224.github.io/my-portfolio/assets/twitter.png',
        github: 'https://github.com/supriya224/twitter-clone',
        title: 'Twitter-clone',
        text: 'ReactJs, NextJs ,NextAuth, Firebase, TailwindCss',
    },
    {
        id: 5,
        category: 'Javascript',
        image: 'https://supriya224.github.io/my-portfolio/assets/dic.png',
        github: 'https://github.com/supriya224/dictinoryApp',
        linkedin: 'https://supriya224.github.io/dictinoryApp/',
        title: 'Dictionary-Web-App',
        text: 'HTML, Css, Javascript, Dictionary-api',
    },
    {
        id: 10,
        category: 'Reactjs',
        image: 'https://supriya224.github.io/my-portfolio/assets/nike.png',
        github: 'https://github.com/supriya224/Nike-Store',
        linkedin: 'https://unique-torrone-70b350.netlify.app/',
        title: 'Nike-store',
        text: 'Vite+ReactJs, Redux,ReactHooks,lodash,Splider, TailwindCss,',
    },
    {
        id: 9,
        category: 'Javascript',
        image: 'https://supriya224.github.io/my-portfolio/assets/quote.png',
        github: ' https://github.com/supriya224/quotoGenerator',
        linkedin: 'https://courageous-hummingbird-dae033.netlify.app/',
        title: 'Quote Generator Web-App',
        text: 'HTML, Css, Javascript, Quote-api',
    },
    {
        id: 6,
        category: 'Javascript',
        image: 'https://supriya224.github.io/my-portfolio/assets/game.png',
        github: 'https://github.com/supriya224/2048Game',
        linkedin: 'https://supriya224.github.io/2048Game/',
        title: '2028 Game',
        text: 'HTML, Css, Javascript',
    },

    {
        id: 11,
        category: 'Reactjs',
        image: 'https://supriya224.github.io/my-portfolio/assets/ecom.png',
        github: 'https://github.com/supriya224/E-Commerece-web-app',
        linkedin: 'https://supriya224.github.io/E-Commerece-web-app/',
        title: 'E-Commerece',
        text: 'ReactJs, ReactHooks, TailwindCss',
    },
    {
        id: 7,
        category: 'Javascript',
        image: 'https://supriya224.github.io/my-portfolio/assets/joke.png',
        github: 'https://github.com/supriya224/jokeGenerator',
        linkedin: 'https://supriya224.github.io/jokeGenerator/',
        title: 'joke-web-App',
        text: 'HTML, Css, Javascript, joke-api',
    },
    {
        id: 16,
        category: 'Typescript',
        image: 'https://github.com/supriya224/my-portfolio/blob/main/public/assets/task.png?raw=true',
        github: 'https://github.com/supriya224/Task-manager-app',
        linkedin: 'https://task-manager-app-dun.vercel.app/',
        title: 'Task Manager App',
        text: `ReactJs, ReactHooks,React-Router,Tailwindcss, typescript`,
    },
    {
        id: 8,
        category: 'Javascript',
        image: 'https://supriya224.github.io/my-portfolio/assets/product.png',
        github: 'https://github.com/supriya224/product-filter',
        linkedin: 'https://brilliant-fairy-6d3109.netlify.app/',
        title: 'ECommerec product-filter',
        text: 'HTML, Css ,Javascript',
    },
    {
        id: 12,
        category: 'Reactjs',
        image: 'https://supriya224.github.io/my-portfolio/assets/zomato.png',
        github: 'https://github.com/supriya224/zomato-clone-app',
        linkedin: '//astounding-alfajores-34473b.netlify.app/',
        title: 'Zomato-Clone',
        text: `ReactJs, ReactHooks,React-Router,Css`,
    },

    {
        id: 13,
        category: 'Typescript',
        image: 'https://supriya224.github.io/my-portfolio/assets/admin.png',
        github: ' https://github.com/supriya224/Admin-Dashboard-typescript',
        linkedin: 'https://elegant-stroopwafel-e2b1f6.netlify.app/',
        title: 'TailAdmin-clone-app',
        text: `vite+ReactJs, Typescript,TailwindCss ReactHooks,React-router-dom,react-apexcharts,flatpickr,apexcharts`,
    },
    {
        id: 14,
        category: 'Typescript',
        image: 'https://github.com/supriya224/my-portfolio/blob/main/public/assets/expanse.png?raw=true',
        github: 'https://github.com/supriya224/expense-task-typescript',
        linkedin: 'https://expense-task-typescript.vercel.app/',
        title: 'Expanse Task',
        text: `ReactJs, ReactHooks,React-Router,Shadcn-ui, typescript`,
    },
    {
        id: 15,
        category: 'Typescript',
        image: 'https://github.com/supriya224/my-portfolio/blob/main/public/assets/weather.png?raw=true',
        github: 'https://github.com/supriya224/weather-app-project',
        linkedin: 'https://weather-app-project-phi.vercel.app/',
        title: 'Weather Task',
        text: `ReactJs, ReactHooks,React-Router,Tailwindcss, typescript`,
    },
]
